export const channels = [
  {
    name: "Multi-Asset",
    description: "This is a feed that combines all content",
    address: "https://webrtc2.newsquawk.com/live/multi_asset-realtime",
    demoChannel: "multi_asset",
    requiredRole: "squawk-multi-asset",
    v2Keyword: "asset:multi_asset",
  },
  {
    name: "Equities",
    description: "This is a feed focused on equities",
    address: "https://webrtc2.newsquawk.com/live/equities-realtime",
    demoChannel: "equities",
    requiredRole: "squawk-equities",
    v2Keyword: "asset:equities",
  },
  {
    name: "Fixed Income",
    description: "This is a feed focused on fixed income",
    address: "https://webrtc2.newsquawk.com/live/fixed_income-realtime",
    demoChannel: "fixed_income",
    requiredRole: "squawk-fixed-income",
    v2Keyword: "asset:fixed_income",
  },
  {
    name: "Energy",
    description: "This is a feed focused on energy",
    address: "https://webrtc2.newsquawk.com/live/energy-realtime",
    demoChannel: "energy",
    requiredRole: "squawk-energy",
    v2Keyword: "asset:energy",
  },
  {
    name: "Forex",
    description: "This is a feed focused on forex",
    address: "https://webrtc2.newsquawk.com/live/forex-realtime",
    demoChannel: "forex",
    requiredRole: "squawk-forex",
    v2Keyword: "asset:forex",
  },
  {
    name: "Metals",
    description: "This is a feed focused on metals",
    address: "https://webrtc2.newsquawk.com/live/metals-realtime",
    demoChannel: "metals",
    requiredRole: "squawk-metals",
    v2Keyword: "asset:metals",
  },
  {
    name: "Audio Test",
    description: "This is a test audio feed",
    address: "https://webrtc2.newsquawk.com/live/audio_test",
    demoChannel: "multi_asset",
    v2Keyword: "asset:audio_test",
  },
  {
    name: "Asia",
    description: "This is a feed focused on Asia",
    v2Only: true,
    v2Keyword: "asset:asia",
  },
];